import Vue from 'vue'
import Router from 'vue-router'
const Home = () =>
    import ('@/views/Home')
const Login = () =>
    import ('@/views/Login')
const Recommend = () =>
    import ('@/views/Recommend')
const Search = () =>
    import ('@/views/Search')
const ResumeDetail = () =>
    import ('@/views/ResumeDetail')
const Register = () =>
    import ('@/views/Register')
const OldLogin = () =>
    import ('@/views/OldLogin')
Vue.use(Router)

export default new Router({
    routes: [{
            path: '/',
            component: Home,
            redirect: '/home'
        },
        {
            path: '/home',
            // name: 'Home',
            component: Home,
            meta: {
                auth: true
            },
            children: [{
                    path: '/',
                    redirect: 'recommend',
                    component: Recommend
                },
                {
                    path: 'recommend',
                    name: 'Recommend',
                    meta: {
                        auth: true
                    },
                    component: Recommend
                },
                {
                    path: 'search',
                    name: 'Search',
                    meta: {
                        auth: true
                    },
                    component: Search
                }
            ]
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/OldLogin',
            name: 'OldLogin',
            component: OldLogin
        },
        {
            path: '/register',
            name: "register",
            component: Register
        }, {
            path: '/resume_detail',
            name: 'ResumenDetail',
            component: ResumeDetail
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js